module.exports = __webpack_public_path__ + "img/fc1.9350aa17.png";